import React, { useEffect, useState } from "react";
import { Sidebar } from "./Sidebar";
import { Prices } from "./Market/Prices/Prices";
import { Production } from "./Market/Production/Production";
import { News } from "./Market/News/News";
import { Transaction } from "./Transaction/Transaction";
import MainRisk from "./Risk/Monitor/MainRisk";
import { RiskPosition } from "./Risk/RiskPosition/RiskPosition";
import { Glossary } from "./Glossary/Glossary";
import { Analytics } from "./Analytics/Analytics";
import { Users } from "./Users/Users";
import Footer from "./Footer";
import Header from "./Header";
import { Home } from "./Home/Home";
import { useApi } from "../services/api";
import { useAuth } from "../auth/useAuth";
import { trackModuleView } from "../services/analytics";


const NotForYou = () => (
  <div style={{ marginTop: "80px", textAlign: "center", color: "#575757" }}>
    This page is for administrators. Ask one to grant you the{" "}
    <code>admin</code> role in Logto if you need it.
  </div>
);

export const MainLayout = () => {
  const [menu, setMenu] = useState("Home");
  const { apiFetch } = useApi();
  const { isAdmin } = useAuth();

  // One place records module usage for the whole app.
  useEffect(() => {
    trackModuleView(apiFetch, menu);
  }, [menu, apiFetch]);

  return (
    <>
    <Header menu={menu} setMenu={setMenu} />
    <div style={{ marginTop: '90px' , marginBottom:'50px'}}>
      <Sidebar setMenu={setMenu} menu={menu} />
     { menu === "Home" ? (
        <Home />
      ) : menu === "Prices" || menu === "Market" ? (
        <Prices />
      ) : menu === "News" ? (
        <News />
      ) : menu === "Production" ? (
        <Production />
      ) : menu === "Transaction" ? (
        <Transaction />
      ) : menu === "Risk" || menu === "Monitor" ? (
        <MainRisk />
      ) : menu === "Risk Position" ? (
        <RiskPosition />
      ) : menu === "Glossary" ? (
        <Glossary />
      ) : menu === "Analytics" ? (
        // The header menu hides this for non-admins, but menu state is reachable
        // without it, so the view checks for itself rather than rendering a
        // dashboard whose every request will come back 403.
        isAdmin ? <Analytics /> : <NotForYou />
      ) : menu === "Users" ? (
        isAdmin ? <Users /> : <NotForYou />
      )
      
       : (
        ""
      )}
      </div>
    
     <Footer/>
  
    </>
  );
};
